var React = require('react');

function X (props) {
    return React.createElement("svg",props,[React.createElement("line",{"id":"Line_156","data-name":"Line 156","y2":"10","transform":"translate(5)","fill":"none","stroke":"#383b23","strokeWidth":"1","key":0}),React.createElement("line",{"id":"Line_157","data-name":"Line 157","x1":"10","transform":"translate(0 5)","fill":"none","stroke":"#383b23","strokeWidth":"1","key":1})]);
}

X.defaultProps = {"id":"Group_656","data-name":"Group 656","width":"10","height":"10","viewBox":"0 0 10 10"};

module.exports = X;

X.default = X;
